import React from "react";

function MetabaseExamplePage() {
  return (
    <div className="w-full">
      <div className="flex flex-column lg:flex-row gap-3 min-w-0">
        <div className="w-full min-w-0">
          <iframe
            src="https://metabase.harpier.dev/public/question/2a512e48-0faf-433b-95c6-a83842e25543"
            frameBorder="0"
            width="100%"
            height="600"
            allowTransparency
            title="Reason Breakdown"
          ></iframe>
        </div>
        <div className="w-full min-w-0">
          <iframe
            src="https://metabase.harpier.dev/public/question/b178dfdc-b2a5-4c87-9bff-eeeb0a8a6903"
            frameBorder="0"
            width="100%"
            height="600"
            allowTransparency
            title="Reason Average Rating"
          ></iframe>
        </div>
      </div>
      <div className="mt-3">
        <iframe
          src="https://metabase.harpier.dev/public/question/402ea8ab-751e-4777-9496-f3168a1a71a4"
          frameBorder="0"
          width="100%"
          height="600"
          allowTransparency
          title="Matches"
        ></iframe>
      </div>
    </div>
  );
}

export default MetabaseExamplePage;
